const idCard = {
  getMessage: field => field + '格式错误!',
  validate: (item) => {
    let value='';
    if (typeof(item)==='string') {
      value=item;
    } else {
      value=item.value
    }
    if (value==='') {
      return true
    }
    return /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/.test(value);
  }
};
const phone={
  getMessage: ()=> '您输入的手机号码格式不正确',
  validate: (item) => {
    let value='';
    if (typeof(item)==='string') {
      value=item;
    } else {
      value=item.value
    }
    console.log(value)
    if (value==='') {
      return true
    }
    return /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/.test(value);
  }
};
const captcha={
  getMessage: ()=> '您输入的验证码格式不正确',
  validate: (item) => {
    let value='';
    if (typeof(item)==='string') {
      value=item;
    } else {
      value=item.value
    }
    if (value==='') {
      return true
    }
    return /^\d{6}$/.test(value);
  }
};
const Ruler = {idCard,phone,captcha};
export default Ruler;



// WEBPACK FOOTER //
// ./src/plugins/vee-validate/rules.js